module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rpref"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0007#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0008#pt01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rprog"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0009#prog"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0010#ch01"
    }
  }, [_vm._v("1  Intimate and Momentous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0011#ch02"
    }
  }, [_vm._v("2  Seasons and Circulations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0012#ch03"
    }
  }, [_vm._v("3  Lilacs and Passing Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0013#ch04"
    }
  }, [_vm._v("4  Noting with a Climate Eye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0014#ch05"
    }
  }, [_vm._v("5  Bedrock and Baselines")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0015#pt02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0016#ch06"
    }
  }, [_vm._v("6  The Green World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0017#ch07"
    }
  }, [_vm._v("7  Wriggles, Buzzes, and Calls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0018#ch08"
    }
  }, [_vm._v("8  Feathers and Phenophases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0019#ch09"
    }
  }, [_vm._v("9  Warm Blood and Live Birth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0020#ch10"
    }
  }, [_vm._v("10  The Atmosphere at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0021#pt03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0022#ch11"
    }
  }, [_vm._v("11  Ground Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0023#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rread"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0024#read"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0025#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rfn_notes"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihineline0026#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2368ef78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hineline-0006.vue
// module id = 69
// module chunks = 0